import { PageHeader } from '@/components/layout';
import { Card } from '@/components/common';
import { ProviderLocator } from '@/components/directory/ProviderLocator';

/**
 * DQ-346: the cashless hospital locator.
 *
 * `/hospitals` is public -- the directory is shown to everyone -- and renders
 * standalone; `/cashless-hospitals` is the same locator inside the customer
 * portal, where the insurer of the customer's health policy is preselected.
 */
export function HospitalLocatorPage({ embedded = false }: { embedded?: boolean }) {
  if (embedded) {
    return (
      <div>
        <PageHeader
          title="Cashless Hospitals"
          subtitle="Find a network hospital for your health insurer by name, city or pincode"
        />
        <Card>
          <ProviderLocator kind="hospital" />
        </Card>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <header className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">Cashless Hospital Locator</h1>
          <p className="mt-1 text-gray-600 dark:text-gray-400">
            Find a network hospital by name, city or pincode, and see which insurers it is cashless with.
          </p>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <ProviderLocator kind="hospital" />
      </main>
    </div>
  );
}
